/** What a page view tells the admin about the page: its route pattern and the name people see. */
export type PageView = { route: string; name: string | null };

type PageMatch = { fullPath: string; loaderData?: unknown };

const crumbOf = (match: PageMatch) => {
  const data = match.loaderData;
  return data && typeof data === "object" && "crumb" in data && typeof data.crumb === "string" ? data.crumb : null;
};

const trimSlash = (path: string) => (path.length > 1 ? path.replace(/\/$/, "") : path);

/**
 * Names a page from the breadcrumb its routes already return ("Finanse › Płatności") and keys it by
 * the route pattern, so every client's page counts as one `/trainees/$clientId`. A route that adds a
 * `$param` segment is left out of the name: its crumb is the record's own name (a client's), which
 * is personal data and would split one page into thousands.
 */
export function pageViewFromMatches(matches: readonly PageMatch[]): PageView {
  const leaf = matches.at(-1);
  const names: string[] = [];
  for (const match of matches) {
    const crumb = crumbOf(match);
    const segment = trimSlash(match.fullPath).split("/").at(-1) ?? "";
    if (!crumb || segment.startsWith("$") || names.at(-1) === crumb) continue;
    names.push(crumb);
  }
  return { route: trimSlash(leaf?.fullPath ?? "/"), name: names.length ? names.join(" › ") : null };
}
